export default "data:image/gif;base64,R0lGODlhEgAMAPEBAAAAzP////8AAOXl5SH5BAAAAAAALAAAAAASAAwAAAIonI+Jwe0fTBCUQietvWwAIDTCR5alNpoqKK4q6pKUWdX2/N36zvd7AQA7"